import React from 'react'

export const Logo = () => {
  return (
    <svg width="64" height="64" xmlns="http://www.w3.org/2000/svg" >
      <title>1</title>
      <g className="layer">
        <title>Layer 1</title>
        <g data-name="Capa 2" id="Capa_2" transform="rotate(-0.859373, 32.555, 32.2)">
          <g data-name="Capa 1" id="Capa_1-2">
            <path className="cls-2" fill="#14CCAA" d="m51.86,30.53c-0.93,0 -1.52,-0.49 -1.52,-1.56l0,-6.72c0,-3.45 -2,-5.31 -5.89,-5.31l-1.73,0l0,3.27l0.72,0c1.78,0 2.58,0.91 2.58,2.47l0,6.16c0,2.02 0.59,2.9 2,3.32c-1.38,0.42 -2,1.3 -2,3.32l0,6.16c0,1.56 -0.83,2.48 -2.58,2.48l-0.49,0l-9.89,-27.17l1.31,30.48l10.09,0c3.9,0 5.89,-1.85 5.89,-5.31l0,-6.72c0,-1.08 0.59,-1.56 1.52,-1.56l1.19,0l0,-3.3l-1.2,0l-0.01,0z" id="svg_1"/>
            <path className="cls-1" fill="#17375f" d="m22.14,44.17l-0.49,0c-1.78,0 -2.58,-0.91 -2.58,-2.48l0,-6.16c0,-2.02 -0.59,-2.9 -2,-3.32c1.38,-0.42 2,-1.31 2,-3.32l0,-6.16c0,-1.56 0.83,-2.47 2.58,-2.47l0.72,0l0,-3.3l-1.76,0c-3.9,0 -5.89,1.85 -5.89,5.31l0,6.72c0,1.07 -0.59,1.56 -1.52,1.56l-1.16,0l0,3.32l1.19,0c0.93,0 1.52,0.49 1.52,1.56l0,6.72c0,3.45 2,5.31 5.89,5.31l10.09,0l1.27,-30.51l-9.87,27.22l0,0.01z" id="svg_2"/>
          </g>
        </g>
      </g>
    </svg>
  )
}